import React, { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { HeaderCommon } from '@insurancemenu/imenu-components-lib';
import { Announcement } from '@insurancemenu/imenu-components-lib/dist/types/AnnouncementsModal';
import { eeRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { GET_ANNOUNCEMENTS } from 'api/announcementService';
import { GET_AGENCY_STATUS } from 'api/queries/userService';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { AgencyStatus } from '@insurancemenu/imenu-components-lib/dist/types';

const HeaderCommonWrapper: React.FC = observer(() => {
  const {
    userStore: { userRoles, userInfo },
    domainStoreV2: { domainHeader },
  } = useRootStore();

  const convertedUserRoles = userRoles.map((role) => toJS(role)).slice();

  const getAgencyStatusQuery = useLazyQuery<{
    getAgencyStatus: AgencyStatus;
  }>(GET_AGENCY_STATUS);

  const getAnnouncementsQuery = useLazyQuery<{
    getAnnouncements: Announcement[];
  }>(GET_ANNOUNCEMENTS);

  useEffect(() => {
    if (convertedUserRoles.length > 0 && !eeRights(convertedUserRoles)) {
      void getAgencyStatusQuery[0]();
    }
  }, [getAgencyStatusQuery[0], userRoles]);

  useEffect(() => {
    void getAnnouncementsQuery[0]();
  }, [getAnnouncementsQuery[0]]);

  return (
    <HeaderCommon
      currentHeaderStyleId={domainHeader.headerStyleId}
      userAccountInfo={toJS(userInfo)}
      currentUserRoles={userRoles.map((role) => toJS(role)).slice()}
      status={getAgencyStatusQuery[1].data?.getAgencyStatus || AgencyStatus.REGULAR}
      announcements={getAnnouncementsQuery[1].data?.getAnnouncements}
      locationPathName={window.location.pathname}
      showStageBanner
    />
  );
});

export default HeaderCommonWrapper;
